import { Controller } from "../../lib/stimulus-shim"

// Controller pour cacher/afficher les boutons au scroll (mobile uniquement)
export default class extends Controller {
  static targets = ["buttons"]

  connect() {
    this.lastScrollY = window.scrollY
    this.threshold = 10
    this.hideAfter = 60 // Cacher après 60px de scroll

    // Bind pour garder le contexte
    this.handleScroll = this.handleScroll.bind(this)

    // Écouter le scroll uniquement sur mobile
    if (window.innerWidth < 1024) {
      window.addEventListener('scroll', this.handleScroll, { passive: true })
    }
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    // Skip sur desktop
    if (window.innerWidth >= 1024) return

    const currentScrollY = window.scrollY

    // Vérifier si le changement est significatif
    if (Math.abs(currentScrollY - this.lastScrollY) < this.threshold) {
      return
    }

    // Scroll down + au-delà du seuil → cacher
    if (currentScrollY > this.lastScrollY && currentScrollY > this.hideAfter) {
      this.hide()
    }
    // Scroll up → afficher
    else if (currentScrollY < this.lastScrollY) {
      this.show()
    }

    this.lastScrollY = currentScrollY
  }

  hide() {
    this.buttonsTarget.classList.add('-translate-y-full', 'opacity-0')
    this.buttonsTarget.classList.remove('translate-y-0', 'opacity-100')
  }

  show() {
    this.buttonsTarget.classList.remove('-translate-y-full', 'opacity-0')
    this.buttonsTarget.classList.add('translate-y-0', 'opacity-100')
  }
}